import { useCallback, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";

export const LIBRARY_PAGE_SIZES = [12, 24, 40, 48, 50];
const sorts = ["newest", "title_asc", "title_desc", "last_read"];
const collections = ["all", "free", "gifted"];

export default function useMyLibraryFilters() {
	const location = useLocation();
	const history = useHistory();
	const filters = useMemo(() => {
		const params = new URLSearchParams(location.search);
		const page = Number(params.get("page"));
		const rows = Number(params.get("rows"));
		return {
			page: Number.isSafeInteger(page) && page > 0 ? page : 1,
			rowsPerPage: LIBRARY_PAGE_SIZES.includes(rows) ? rows : 24,
			searchTerm: (params.get("search_term") || "").slice(0, 255),
			sort: sorts.includes(params.get("sort")) ? params.get("sort") : "newest",
			collection: collections.includes(params.get("collection")) ? params.get("collection") : "all",
			view: params.get("view") === "list" ? "list" : "grid",
		};
	}, [location.search]);
	const change = useCallback((patch, { replace = false, resetPage = false } = {}) => {
		const current = history.location;
		const params = new URLSearchParams(current.search);
		if (resetPage) params.delete("page");
		params.delete("first_page");
		Object.entries(patch).forEach(([key, value]) => {
			if (value == null || value === "" || (key === "page" && Number(value) === 1)
				|| (key === "sort" && value === "newest") || (key === "collection" && value === "all")
				|| (key === "view" && value === "grid")) params.delete(key);
			else params.set(key, value);
		});
		const search = params.toString() ? "?" + params : "";
		if (search !== current.search) history[replace ? "replace" : "push"]({ ...current, search });
	}, [history]);
	return {
		...filters,
		changeSearchTerm: useCallback((value, options) => change({ search_term: value }, { ...options, resetPage: true }), [change]),
		changeCollection: (value) => change({ collection: value }, { resetPage: true }),
		changeSort: (value) => change({ sort: value }, { resetPage: true }),
		changeView: (value) => change({ view: value }),
		changePage: (value, options) => change({ page: value }, options),
		changeRowsPerPage: (value) => change({ rows: value }, { resetPage: true }),
		clearFilters: () => change({ search_term: null, collection: null }, { resetPage: true }),
	};
}
